import { IDENTIFIERS, updateValueByIdentifier } from '@wix/advanced-seo-utils';
import { assertNotOptional } from '@wix/seo-common-core';
import { getItemDataExtractor } from '@wix/seo-data-extractors/http';
export const setTitleTag = async (httpClient, _errorHandler, itemType, value, pageId) => {
  var _seoDataExtractor$get;
  const seoDataExtractor = getItemDataExtractor(itemType);
  assertNotOptional(seoDataExtractor, 'seoDataExtractor');
  const response = await seoDataExtractor.fetchSingle({
    httpClient
  }, pageId);
  const itemSeoData = (_seoDataExtractor$get = seoDataExtractor.getItemsSeoData(response)) == null ? void 0 : _seoDataExtractor$get[0];
  assertNotOptional(itemSeoData, 'itemSeoData');
  const seoData = seoDataExtractor.getSeoData(itemSeoData);
  const updatedSeoData = updateValueByIdentifier(seoData ?? {
    tags: []
  }, IDENTIFIERS.TITLE, value);
  await seoDataExtractor.updateSeoData({
    httpClient
  }, true, itemSeoData, updatedSeoData);
};
//# sourceMappingURL=set-title-tag.js.map